import { typographyV2 } from '@toggle/design-system';
import styled from 'styled-components';

export const TooltipWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
`;

export const RightWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

export const BottomWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
`;

export const RecapWrapper = styled.div`
  ${typographyV2.bodySm};
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const RecapValue = styled.span<{ $isNegative: boolean }>`
  color: ${props =>
    props.$isNegative ? 'var(--viz-bearish)' : 'var(--viz-bullish)'};
  padding-right: 0.3em;
`;

export const RecapLabel = styled.span`
  color: var(--text-soft);
`;

export const ValueWrapper = styled.div`
  ${typographyV2.bodySm};
`;

export const DescriptionLabel = styled.div`
  ${typographyV2.bodySm};
  color: var(--text-soft);
`;

export const TitleLabel = styled.div`
  ${typographyV2.titleSm};
`;
